<template>
    <div>
      <v-tabs
        v-model="active"
        color="primary"
        dark
        slider-color="secondary"
      >
        <v-tab
          v-for="(item, i) in items"
          :key="i"
          ripple
          @click="logMixpanel(item.title)"
          data-cy="tab-view-title"
        >
          {{ item.title }}
        </v-tab>
        <v-tab-item
          v-for="(item, i) in items"
          :key="i"
        >
          <v-card flat>
            <v-card-text v-if="item.title=='Updates'">
              <UpdatesTab 
                :dataset="dataset"
                :editMode="editMode"
              ></UpdatesTab>
            </v-card-text>
            <v-card-text v-if="item.title=='Resources'">
              <ResourceTab
                :dataset="dataset"
                :editMode="editMode"
              ></ResourceTab>
            </v-card-text>
            <v-card-text v-if="item.title=='Milestones'">
              <MilestoneTab 
                :dataset="dataset"
                :editMode="editMode"
              ></MilestoneTab>
            </v-card-text>
            <v-card-text v-if="item.title=='Media'">
              <MediaTab 
                :dataset="dataset"
                :editMode="editMode"
              ></MediaTab>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>
</template>

<script>
import MilestoneTab from './MilestoneTab.vue'
import UpdatesTab from './UpdatesTab.vue'
import MediaTab from './MediaTab.vue'
import ResourceTab from './ResourceTab.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    MilestoneTab,
    UpdatesTab,
    MediaTab,
    ResourceTab
  },
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [
        {title: 'Updates', text: 'No recent updates'},
        {title: 'Milestones', text: 'No milestones listed'},
        {title: 'Resources', text: 'No resources listed'},
        {title: 'Media', text: 'No Media Available'}
      ],
      active: null
    }
  },
  methods: {
    logMixpanel (name) {
      if (this.mixpanelEnabled) {
        this.$ma.trackEvent({category: 'click', action: `tabVue: ${name}`})
      }
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentDataset',
      'mixpanelEnabled'
    ]),
    dataset () {
      return this.getCurrentDataset
    }
  }
}
</script>
